import "./input.css";

import React from "react";
import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import AddSet from "./pages/sets/AddSet";
import ProtectedRoutes from "./pages/ProtectedRoutes";
import ViewSet from "./pages/sets/ViewSet";
import AddFC from "./pages/flashcards/AddFC";
import EditFC from "./pages/flashcards/EditFC";
import PreviewSet from "./pages/sets/PreviewSet";
import DeleteFC from "./pages/flashcards/DeleteFC";
import DeleteSet from "./pages/sets/DeleteSet";
import Pretest from "./pages/tests/Pretest";
import Test from "./pages/tests/Test";
import Results from "./pages/tests/Results";
import Login from "./pages/Login";
import Register from "./pages/Register";
import NotFound from "./pages/NotFound";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { AnimatePresence } from "framer-motion";

function App() {
  const location = useLocation();

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes key={location.pathname} location={location}>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword/:token" element={<ResetPassword />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/addset" element={<AddSet />} />
          <Route path="/dashboard/deleteset/:id" element={<DeleteSet />} />
          <Route
            path="/dashboard/set/preview/:setname"
            element={<PreviewSet />}
          />
          <Route path="/dashboard/set/pretest/:setname" element={<Pretest />} />
          <Route path="/dashboard/set/test/:setname" element={<Test />} />
          <Route
            path="/dashboard/set/test/:setname/results"
            element={<Results />}
          />
          <Route path="/dashboard/set/:setname" element={<ViewSet />} />
          <Route path="/dashboard/set/:setname/addcard" element={<AddFC />} />
          <Route
            path="/dashboard/set/:setname/editcard/:id"
            element={<EditFC />}
          />
          <Route
            path="/dashboard/set/:setname/deletecard/:id"
            element={<DeleteFC />}
          />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

// Placed the context provider here so that <App/> can call useLocation()
const Root = () => <BrowserRouter><App /></BrowserRouter>; // prettier-ignore

render(<Root />, document.getElementById("root"));
